import React from 'react';
interface AVSliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  orientation?: 'vertical' | 'horizontal';
  showValue?: boolean;
  height?: string;
  color?: 'green' | 'blue' | 'amber';
}
export function AVSlider({
  value,
  onChange,
  min = 0,
  max = 100,
  label,
  orientation = 'vertical',
  showValue = true,
  height = 'h-64',
  color = 'green'
}: AVSliderProps) {
  // Calculate percentage for fill
  const percentage = (value - min) / (max - min) * 100;
  const colorClasses = {
    green: 'bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.4)]',
    blue: 'bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.4)]',
    amber: 'bg-amber-500 shadow-[0_0_10px_rgba(245,158,11,0.4)]'
  };
  return <div className={`flex ${orientation === 'vertical' ? 'flex-col' : 'flex-row'} items-center justify-center gap-3 p-2`} data-id="element-307">
      {/* Track Container */}
      <div className={`
          relative bg-neutral-900 rounded-lg border border-neutral-700 overflow-hidden
          ${orientation === 'vertical' ? `w-16 ${height}` : 'h-16 w-full'}
        `} data-id="element-308">
        {/* Fill */}
        <div className={`absolute bottom-0 left-0 transition-all duration-100 ease-out ${colorClasses[color]}`} style={{
        width: orientation === 'vertical' ? '100%' : `${percentage}%`,
        height: orientation === 'vertical' ? `${percentage}%` : '100%'
      }} data-id="element-309" />

        {/* Grid lines / Ticks overlay */}
        <div className="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-20 p-1" data-id="element-310">
          {[...Array(10)].map((_, i) => <div key={i} className={`bg-white ${orientation === 'vertical' ? 'h-px w-full' : 'w-px h-full'}`} data-id="element-311" />)}
        </div>

        {/* Input Range (Invisible but interactive) */}
        <input type="range" min={min} max={max} value={value} onChange={e => onChange(Number(e.target.value))} className={`
            absolute inset-0 w-full h-full opacity-0 cursor-pointer
            ${orientation === 'vertical' ? 'appearance-slider-vertical' : ''}
          `} style={orientation === 'vertical' ? {
        writingMode: 'bt-lr' as any,
        WebkitAppearance: 'slider-vertical'
      } : {}} data-id="element-312" />
      </div>

      {/* Label & Value */}
      <div className="text-center space-y-1" data-id="element-313">
        {label && <div className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-314">
            {label}
          </div>}
        {showValue && <div className="text-xl font-mono font-bold text-white tabular-nums" data-id="element-315">
            {value}%
          </div>}
      </div>
    </div>;
}